const listCollaborator = (query) => {
	return `query ListCollaborator(
		$page: Int
		$size: Int
	) {
		listPhaseCollaborator(
			page: $page
			size: $size
		){
			isEnding
			collaborators{
				${query}
			}
		}
	}`;
}

export default listCollaborator;
